import { Grid, Button, Typography, Box, Pagination } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useGetOrganizationUserQuery } from '../features/api/rest/apiOrganizationsSlice';
import { useGetOrganizationBrandQuery } from '../features/api/rest/apiBrandOrganizationSlice';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import BrandCard from './BrandCard';
import Error from './Error';
import Spinner from './Spinner';
import BrandOrganizationDialog from './BrandOrganizationDialog';

function BrandOrganization({ searchParamsName = '' }) {
  const { opk } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const componentSearchParamsName = searchParamsName ? `${searchParamsName}_` : '';
  const brandsForPage = parseInt(searchParams.get(`${componentSearchParamsName}psize`), 10) || 18;
  const brandPage = parseInt(searchParams.get(`${componentSearchParamsName}page`), 10) || 1;
  const ordering = searchParams.get(`${componentSearchParamsName}ordering`) || 'id';
  const [isAdding, setIsAdding] = useState(false);
  const { data: profile } = useGetProfileQuery();
  const { data: users = [] } = useGetOrganizationUserQuery(opk);
  const { brands, brandsCount, isLoading, isFetching, isError } = useGetOrganizationBrandQuery(
    { opk, ordering, page: brandPage, psize: brandsForPage },
    {
      selectFromResult: (result) => ({
        ...result,
        brands: result.data?.results,
        brandsCount: result.data?.count || 0,
      }),
    }
  );
  let SystemAdmin = false;
  let OrgAdmin = false;
  const permission = () => {
    if (profile.is_staff) {
      SystemAdmin = true;
    }
    OrgAdmin = users.some((user) => user.is_admin && profile.id === user.user);
    if (OrgAdmin || SystemAdmin) return true;
    return false;
  };
  const handlePageChange = (page) => {
    searchParams.set(`${componentSearchParamsName}page`, page);
    navigate(`${pathname}?${searchParams.toString()}`);
  };

  if (isLoading || isFetching) return <Spinner />;

  if (isError) return <Error />;

  const pagination = <Pagination sx={{ my: 2 }} count={Math.ceil(brandsCount / brandsForPage)} page={brandPage} onChange={(event, newPage) => handlePageChange(newPage)} />;

  return (
    <Box>
      {permission() && (
        <Button
          sx={{ mt: 2 }}
          startIcon={<AddIcon />}
          variant="contained"
          color="primary"
          onClick={() => {
            setIsAdding(true);
          }}
        >
          {t('organizations.brand.add')}
        </Button>
      )}

      {brandsCount === 0 ? (
        <Typography variant="h5" sx={{ mt: 3 }}>
          {t('organizations.brand.noBrands')}
        </Typography>
      ) : (
        <>
          {pagination}
          <Grid id="Brand_Grid">{brands && brands.map((brand) => <BrandCard name={brand?.name} key={brand?.id} id={brand?.id} />)}</Grid>
          {pagination}
        </>
      )}
      <BrandOrganizationDialog actionType="add" isOpen={isAdding} setIsOpen={setIsAdding} />
    </Box>
  );
}
export default BrandOrganization;

BrandOrganization.propTypes = {
  searchParamsName: PropTypes.string,
};
